module.exports = { apiServer: 'https://ns-api.win.eventizer.hk', AdminServer: 'https://ns-admin.win.eventizer.hk', env: 'prod' };
